import React, { useState, useEffect } from 'react';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { Helmet } from "react-helmet";
import { renderWeaponIcons, renderWeaponFx, useWeaponPopup, WeaponPointsModal } from './WeaponFx';

function RegionHome() {
	const [cookies] = useCookies(['user']);
	const user_id = cookies.user_id;
	const token = cookies.token;
    let history = useHistory();
    const [card, setCard] = useState('');
    const [warUpdate, setWarUpdate] = useState('');
    const { weaponPopup, showWeaponPoints } = useWeaponPopup();
    const row = [];
    const [kingdomData, setKingdomData] = useState({"status":"failuer","war_message":"e","kd_name":""});
	useEffect(() => {
		getDistData();
        getAllLiveWar();
	}, []);

	const [distData, setDistData] = useState({"status":"failuer"});
	const [error1, setError] = useState(false);
    const [bar_style, setBarStyle] = useState({width: "0%" ,ariaValuenow:"33", ariaValuemin:"0", ariaValuemax:"100"});
    const [text_pos, setTextPos] = useState({marginLeft: "0%"});
    const [kdLink, setKdLink] = useState('');
	const getDistData = async () => {

		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json','token':token,'userId':user_id  },
			body: JSON.stringify({dist_user_id:user_id}),
			
		};
		const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-bor-data', requestOptions);

		const res = await response.json();
        console.log(res);
        // setBarStyle({width: data.bar_length + "%" ,ariaValuenow:"33", ariaValuemin:"0", ariaValuemax:"100"});
        // setTextPos({marginLeft: data.text_pos + "%"});
		if (res.status !== "success" || res.data.k_id == "NA"){
			setError(true);
			console.log(error1);
		}
        const data = res.data;
		setDistData(data);
        // setKingdomData({"status":"success","war_message":"e","kd_name":data.kd_name});
        console.log(data);
        let htm = '';
        if(data.war_status == 1){
            let kd1per = {width : (data.kd1_points*100 / (data.kd1_points + data.kd2_points)).toFixed(0)+"%"};
            let kd2per = {width : (100 - (data.kd1_points*100 / (data.kd1_points + data.kd2_points)).toFixed(0))+"%"};
            if(data.kd1_points == 0 && data.kd2_points == 0){
                kd1per = {width : "50%"};
                kd2per = {width : "50%"};
            }
            htm = <div className="row mb-3">
                    <div className="profile-war-info w-100 px-3">
                        <div className="profile-war-header w-100 profile-flt-l">
                            <div className="w-70 profile-flt-l prof-war-head-left">{data.kd1_name} v/s {data.kd2_name}</div>
                            <Link to={{
                                pathname:"/war-score",
                                state: [data, '']
                            }} className="color-white">
                            <div className="w-30 profile-flt-l prof-war-head-right">Tap to view</div>
                            </Link>
                            <div className="w-70 profile-flt-l prof-war-head-left">Battle No. {data.battle_no}</div>
                        </div>
                        <div className="profile-war-data-score w-100 profile-flt-l">
                            <div className="score-range w-100">
                                <div className="score-range-left profile-flt-l" style={kd1per}>&nbsp;</div>
                                <div className="score-range-right profile-flt-l" style={kd2per}>&nbsp;</div>
                            </div>
                        </div>
                        <div className="profile-war-data-bottom w-100 profile-flt-l">
                            <div className="w-50 profile-flt-l text-alg-left">
                                <div className="w-100 profile-flt-l score-team">{data.kd1_name}</div>
                                <div className="w-100 profile-flt-l team-score">{data.kd1_points.toLocaleString('en-In', {maximumFractionDigits:0})}</div>
                            </div>
                            <div className="w-50 profile-flt-l text-alg-right">
                                <div className="w-100 profile-flt-l score-team">{data.kd2_name}</div>
                                <div className="w-100 profile-flt-l team-score">{data.kd2_points.toLocaleString('en-In', {maximumFractionDigits:0})}</div>
                            </div>
                        </div>
                    </div>
                </div>;
        } else if(data.war_status == 2) {
            let opp_name = data.kd1_name;
            if(opp_name == data.kd_name){
                opp_name = data.kd2_name;
            }
            htm = <div className="row mb-3">
                    <div className="profile-war-info w-100 px-3">
                        <div className="profile-war-header w-100">
                            <div className="w-70 profile-flt-l prof-war-head-left">Battle No. {data.battle_no}</div>
                            <div className="w-30 profile-flt-l prof-war-head-right">&nbsp;</div>
                        </div>
                        <div className="profile-war-data w-100">
                            <div className="w-80 profile-flt-l prof-war-middle-left">{opp_name}</div>
                            <div className="w-20 profile-flt-l">
                                <div className="w-100 profile-flt-l prof-war-schedule-box">
                                    <div className="w-100 sched-date">{data.next_war_day}</div>
                                    <div className="w-100 sched-month">{data.next_war_month}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>;
        } else if(data.war_status == 4){
            htm = <div className="row mb-3">
                    <div className="profile-war-info w-100 px-3">
                        <div className="profile-war-header w-100">
                            <div className="w-70 profile-flt-l prof-war-head-left">{data.kd1_name} v/s {data.kd2_name}</div>
                            <Link to={{
                                pathname:"/war-score",
                                state: [data, '']
                            }} className="color-white">
                            <div className="w-30 profile-flt-l prof-war-head-right">Tap to view</div>
                            </Link>
                            <div className="w-70 profile-flt-l prof-war-head-left">Battle No. {data.battle_no}</div>
                        </div>
                        <div className="profile-war-data w-100">
                            <img src={require("./../images/you-won-home.png").default} alt="chat" className="img-fluid" />
                        </div>
                    </div>
                </div>;
        } else if(data.war_status == 3){
            htm = <div className="row mb-3">
                    <div className="profile-war-info w-100 px-3">
                        <div className="profile-war-header w-100">
                            <div className="w-70 profile-flt-l prof-war-head-left">{data.kd1_name} v/s {data.kd2_name}</div>
                            <Link to={{
                                pathname:"/war-score",
                                state: [data, '']
                            }} className="color-white">
                            <div className="w-30 profile-flt-l prof-war-head-right">Tap to view</div>
                            </Link>
                            <div className="w-70 profile-flt-l prof-war-head-left">Battle No. {data.battle_no}</div>
                        </div>
                        <div className="profile-war-data w-100">
                            <img src={require("./../images/you-lose-home.png").default} alt="chat" className="img-fluid" />
                        </div>
                    </div>
                </div>;
        }
        setCard(htm);
	};
	
    const getAllLiveWar = async () => {
        const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json','token':token,'userId':user_id  },
			body: JSON.stringify({user_id:user_id}),
			
		};
        console.log(requestOptions);
		const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-all-live-war', requestOptions);

		 var data = await response.json();
        // data = '{"status":"success","wars":[{"kd1_name":"A P Aggressive Achievers","kd2_name":"Kalyan Da King","kd1_points":100,"kd2_points":150,"status":2,"battle_no":280,"date":"2026-09-01","weapons":{"kd1":{"active":["land"],"past":{"water":20,"space":30}},"kd2":{"active":["air"],"past":{"fire":20}}}}]}';
        // data = JSON.parse(data);
        console.log(data);
        if (data.status === "success"){
            row.push(<div key="1111111" className='warUp warUpCol'>
                Battle Updates
            </div>);
            for (const [index, value] of data.wars.entries()) {
                let kd1per = {width : (value.kd1_points*100 / (value.kd1_points + value.kd2_points)).toFixed(0)+"%"};
                let kd2per = {width : (100 - (value.kd1_points*100 / (value.kd1_points + value.kd2_points)).toFixed(0))+"%"};
                if(value.kd1_points == 0 && value.kd2_points == 0){
                    kd1per = {width : "50%"};
                    kd2per = {width : "50%"};
                }
                let status = '';
                if(value.status === 2){
                    status = <img src={require("./../images/live.svg").default} alt="alt" />;
                } else if(value.status === 5){
                    status = <img src={require("./../images/inReview.png").default} alt="alt" />;
                } else {
                    status = <img src={require("./../images/Ended.svg").default} alt="alt" />;
                }
                const kd1Weapons = renderWeaponIcons(value.weapons?.kd1, "kd1-" + index, value.kd1_name, showWeaponPoints, value.kd2_name);
                const kd2Weapons = renderWeaponIcons(value.weapons?.kd2, "kd2-" + index, value.kd2_name, showWeaponPoints, value.kd1_name);
                row.push(<div className="row mb-3 grey" key={"100000"+index}>
                    <div className="w-100 px-3">
                        <div className="profile-war-header w-100 profile-flt-l">
                            <div className="w-70 profile-flt-l prof-war-head-left color-black">{value.kd1_name} v/s {value.kd2_name}</div>
                            <div>
                                <div className="w-30 profile-flt-l prof-war-head-right t-black">{status}</div>
                            </div>
                            <div className="w-70 profile-flt-l prof-war-head-left color-black">Battle No. {value.battle_no}</div>
                        </div>
                        <div className="weapon-row w-100 profile-flt-l">
                            <div className="w-50 profile-flt-l text-alg-left">
                                <div className="weapon-active-row">{kd1Weapons.activeIcons}</div>
                            </div>
                            <div className="w-50 profile-flt-l text-alg-right">
                                <div className="weapon-active-row">{kd2Weapons.activeIcons}</div>
                            </div>
                        </div>
                        <div className="w-100 profile-flt-l">
                            <div className="score-range w-100">
                                <div className="score-range-left profile-flt-l color-black" style={kd1per}>
                                    {renderWeaponFx(value.weapons?.kd1, "kd1fx-" + index, value.weapons?.kd2)}
                                    &nbsp;
                                </div>
                                <div className="score-range-right profile-flt-l color-black" style={kd2per}>
                                    {renderWeaponFx(value.weapons?.kd2, "kd2fx-" + index, value.weapons?.kd1)}
                                    &nbsp;
                                </div>
                            </div>
                        </div>
                        <div className="profile-war-data-bottom w-100 profile-flt-l">
                            <div className="w-50 profile-flt-l text-alg-left">
                                <div className="w-100 profile-flt-l team-score color-black">{value.kd1_points.toLocaleString('en-In', {maximumFractionDigits:0})}</div>
                                <div className="w-100 profile-flt-l score-team color-black">{value.kd1_name}</div>
                                <div className="weapon-past-row">{kd1Weapons.pastIcons}</div>
                            </div>
                            <div className="w-50 profile-flt-l text-alg-right">
                                <div className="w-100 profile-flt-l team-score color-black">{value.kd2_points.toLocaleString('en-In', {maximumFractionDigits:0})}</div>
                                <div className="w-100 profile-flt-l score-team color-black">{value.kd2_name}</div>
                                <div className="weapon-past-row">{kd2Weapons.pastIcons}</div>
                            </div>
                        </div>
                    </div>
                </div>);
            }
            setWarUpdate(row);
        }
    };

	return (
<>
    
        <Helmet link={
            [{"rel": "stylesheet", "href": 'css/Profile.css'},
            {"rel": "stylesheet", "href": 'css/weapon-fx.css'}]
        }/>
		<div className="row no-gutters">
		{ error1 === false && (
            <div className="bg-bor-img application sc">
                <div className="appHeader bg-transparent text-light position-relative">
                <div className="left">
                    <a className="headerButton goBack" onClick={() => history.goBack()} >
                        <img src={require("./../images/back.png").default} alt="back" className="img-fluid" />
                    </a>
                </div>
                <img className="mt-2" src={require("./../images/bor-img.svg").default} alt="alt" />
                {/*<div className="pageTitle">Profile</div>*/}
                {/*<div className="right">
                    <div className="headerButton">
                        <Link to="/faq">
                            <img src={require("./../images/faq.png").default} alt="faq" className="img-fluid" />
                        </Link>
                    </div>
                </div>*/}
                </div>
                {<div className="section mt-2 text-center">
                    <div className="profile-head">
                        <div className="avatar d-block m-auto">
                            <div className="profile-div-rh profile-center" style = {{
                                backgroundImage: `url(${distData.img}) `
                                  }}
                            >
                            </div>
                        </div>
                        <div className="in mt-2">
                        <h3 className="name-2"><span style={{textTransform:`capitalize`}}>{distData.name} Region</span></h3>
                        </div>
                    </div>
                </div>}
                <div className="section bg-white action-sheet-2" id="auH">
                <div className="row justify-center">
                    <div className="col-md-7 col-lg-7 col-7">
                        <div className="card card-point-2">
                            <div className="card-left">
                                <Link to={{
                                    pathname:"/war-history",
                                    state: [distData]
                                }}>
                                    <div className="card-row-top">Matches Won</div>
                                    <div className="card-row-bottom">{distData.wars_won}</div>
                                </Link>
                            </div>
                            <div className="card-right">
                                <Link to={{pathname:"/kingdom-leaderboard",
                                    state:[distData]
                                }} className="">
                                    <div className="card-row-top">Region Rank</div>
                                    <div className="card-row-bottom">{distData.rank}</div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                {card}
                <hr></hr>
                {warUpdate}
                <WeaponPointsModal weaponPopup={weaponPopup} />
                </div>
            </div>            
		)
		}
		{ error1 === true && (
        	<Redirect to='/coming-soon'  />
		)
		}
        <div className="bor_bg"></div>
		</div>

</>
	);
}

export default RegionHome;
